// images slider
document.addEventListener('DOMContentLoaded', function () {
  var swiper = new Swiper('.imgSlider', {
    slidesPerView: 1.4,
    spaceBetween: 20,
    loop: true,
    centeredSlides: true,
    allowTouchMove: false, // Disable dragging/swiping
    autoplay: {
      delay:4000, // 2.5 seconds between slides
      disableOnInteraction: false, // Keep autoplay running after manual nav
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
});

document.addEventListener('DOMContentLoaded', function () {
  var swiper = new Swiper('.blogSlider', {
    slidesPerView: 3,
    spaceBetween: 20,
    loop: true,
    allowTouchMove: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      // Mobile (0px and up)
      0: {
        slidesPerView: 1
      },
      // Tablet (>=768px)
      768: {
        slidesPerView: 2
      },
      // Desktop (>=1024px)
      1024: {
        slidesPerView: 3
      }
    }
  });
});


document.addEventListener('DOMContentLoaded', function () {
  
  var swiper = new Swiper('.reviewSlider', {
    slidesPerView: 2.4,
    spaceBetween: 20,
    loop: true,
    centeredSlides: true,
    allowTouchMove: false, // Disable dragging/swiping
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      0: {  // mobile
        slidesPerView: 1, // still keep half-half look

    centeredSlides: false,
      },
      768: { // tablet
        slidesPerView: 1,
    centeredSlides: false,
      },
      1024: { // desktop
        slidesPerView:2.4, // 3 with halves visible
      }
    }
  });
});





